import styled from "styled-components";

export const SectionHome = styled.section`
    min-height: 100vh;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width:768px){
        min-height: 80vh;
    }
`;

export const ContainerHome = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    padding: 0 20px;
`;

export const GridHome = styled.div`
    display: grid;
    grid-template-columns: 116px repeat(2, 1fr);
    align-items: center;
    justify-content: center;
    column-gap: 2rem;
    padding-top: 5.5rem;

    @media screen and (max-width: 1024px){
        grid-template-columns: 60px repeat(2, 1fr);
        column-gap: 0.5rem;
    }

    @media screen and (max-width:768px){
        grid-template-columns: 0.5fr 3fr max-content;
        padding-top: 4rem;
    }
`